import { Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { isPublishedId } from "library/id-helpers"
import { parentFind } from "library/tree"
import { PlanRoot } from "library/tree/constants"
import { useParams } from "react-router"

export function RegimeDraftPublishedDate() {
    const { id } = useParams()
    const {
        editExtension,
        parentItem,
        payload,
        isRegimeDraftLocked,
        regimeDraftPublishedDate = null,
    } = useBoundContext()

    const isInRegime = parentFind(parentItem, (c) => c[PlanRoot])
    const show = !isPublishedId(id) && !!isInRegime && !!payload && !editExtension && isRegimeDraftLocked

    return (
        <If truthy={show}>
            <Typography data-cy="regime-submitted-for-review-date" variant="caption" sx={{ color: "text.secondary" }}>
                Submitted For Review {new Date(regimeDraftPublishedDate).format("{dd}/{MM}/{yyyy}")}
            </Typography>
        </If>
    )
}
